import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'primereact/button';
import classNames from 'classnames';

import {
  faExclamationCircle,
  faInfoCircle,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';
import styles from './InfoAlertActions.module.scss';

interface InfoButtonProps {
  infoText: string;
  buttonText?: string;
  onClick?: () => void;
  type: 'info' | 'warning' | 'warning-secondary';
}

const InfoButton: React.FC<InfoButtonProps> = ({
  infoText,
  buttonText,
  onClick,
  type,
}) => {
  const secondaryType = type === 'warning' ? faWarning : faExclamationCircle;
  return (
    <div className={classNames(styles.infoContainer, styles[type])}>
      <div className={styles.textRow}>
        <FontAwesomeIcon
          icon={type === 'info' ? faInfoCircle : secondaryType}
          className={styles.icon}
        />
        <div>
          <p>{infoText}</p>
        </div>
      </div>
      {onClick && (
        <div className={styles.actionsRow}>
          <Button label="" link onClick={onClick}>
            <h5>{buttonText}</h5>
          </Button>
        </div>
      )}
    </div>
  );
};

export default InfoButton;
